/**
 * Shared auth utilities for API modules.
 * Used by fish-dash-backend, BAS, and LEK API clients.
 */

/**
 * Add Authorization header if token is provided.
 * @param {Object} headers - Existing headers object
 * @param {string|null} accessToken - Auth0 access token
 * @returns {Object} Headers with optional Authorization
 */
export const withAuth = (headers = {}, accessToken) => {
  if (accessToken) {
    return { ...headers, Authorization: `Bearer ${accessToken}` };
  }
  return headers;
};
